import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function FullLoader() {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-soma-surface">
      <div className="h-10 w-10 animate-spin rounded-full border-2 border-soma-border border-t-soma-brand" />
    </div>
  );
}

export default function ProtectedRoute({ role, children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/practitioner"} replace />;
  }
  return children;
}
